<template>
  <el-dialog title="办理完成" :visible.sync="visible" width="650px" custom-class="repair-design-dialog" @close="resetForm">
    <el-form ref="form" :model="formData" label-width="86px" class="repair-dialog-form">
      <el-form-item label="维修类型" prop="maintenanceType" :rules="[{ required: true, message: '请选择维修类型', trigger: 'change' }]">
        <el-select v-model="formData.maintenanceType" placeholder="请选择" class="repair-dialog-control">
          <el-option v-for="item in maintenanceTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
      <el-form-item label="说明" prop="context" :rules="[{ required: true, message: '请输入说明', trigger: 'blur' }]">
        <el-input v-model="formData.context" type="textarea" :rows="4" placeholder="请输入" class="repair-dialog-control" />
      </el-form-item>
      <el-form-item label="图片" prop="photos" :rules="[{ required: true, validator: validatePhotos, trigger: 'change' }]">
        <upload-image-url ref="repairUpload" :image-count="6" @notifyUploadCoverImage="handleRepairImage" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer repair-dialog-footer">
      <el-button class="dialog-cancel-btn" @click="visible = false">取消</el-button>
      <el-button type="primary" class="dialog-submit-btn" :loading="submitting" @click="submitForm">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/community/communityApi'
import { completeRepair } from '@/api/work/repairPoolManageApi'
import { getUserName } from '@/api/user/userApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
  name: 'FinishRepairDialog',
  components: { UploadImageUrl },
  data() {
    return {
      visible: false,
      submitting: false,
      maintenanceTypes: [],
      currentRepair: {},
      formData: {
        repairId: '',
        repairType: '',
        repairObjType: '',
        publicArea: '',
        repairChannel: '',
        maintenanceType: '',
        context: '',
        photos: []
      }
    }
  },
  methods: {
    async open(repair) {
      this.currentRepair = repair || {}
      this.formData = {
        repairId: this.currentRepair.repairId || '',
        repairType: this.currentRepair.repairType || '',
        repairObjType: this.currentRepair.repairObjType || '',
        publicArea: this.currentRepair.publicArea || '',
        repairChannel: this.currentRepair.repairChannel || '',
        maintenanceType: this.currentRepair.maintenanceType || '',
        context: '',
        photos: []
      }
      this.visible = true
      if (this.maintenanceTypes.length === 0) {
        this.maintenanceTypes = await getDict('r_repair_pool', 'maintenance_type')
      }
      if (!this.maintenanceTypes.some(item => item.statusCd === this.formData.maintenanceType)) {
        this.formData.maintenanceType = ''
      }
      this.$nextTick(() => {
        if (this.$refs.repairUpload) {
          this.$refs.repairUpload.clearImages()
        }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleRepairImage(photos) {
      this.formData.photos = photos.map(photo => ({ photo }))
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('photos')
        }
      })
    },
    validatePhotos(rule, value, callback) {
      if (!this.formData.photos || this.formData.photos.length === 0) {
        callback(new Error('请上传图片'))
        return
      }
      callback()
    },
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const params = {
            ...this.formData,
            userName: getUserName()
          }
          await completeRepair(params)
          this.$message.success(this.$t('common.operationSuccess'))
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || '办理完成失败')
        } finally {
          this.submitting = false
        }
      })
    },
    resetForm() {
      this.submitting = false
      this.currentRepair = {}
      this.formData = {
        repairId: '',
        repairType: '',
        repairObjType: '',
        publicArea: '',
        repairChannel: '',
        maintenanceType: '',
        context: '',
        photos: []
      }
      if (this.$refs.repairUpload) {
        this.$refs.repairUpload.clearImages()
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>

<style scoped>
.repair-dialog-form { padding: 8px 24px 0; }
.repair-dialog-form >>> .el-form-item { margin-bottom: 24px; }
.repair-dialog-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; white-space: nowrap; }
.repair-dialog-control { width: 100%; }
.repair-dialog-form >>> .el-input__inner { height: 38px; border-radius: 8px; border-color: #DCE6F5; }
.repair-dialog-form >>> .el-textarea__inner { border-radius: 8px; border-color: #DCE6F5; resize: none; }
.repair-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.dialog-cancel-btn, .dialog-submit-btn { width: 74px; height: 38px; padding: 0; border-radius: 10px; }
.dialog-cancel-btn { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.dialog-submit-btn { background: #0E76FF; border-color: #0E76FF; }
</style>
